import { request } from '@/utils/request';
import type { ApiResponse, Result, WrappedResult } from './types';

const settingsApi = {
  get(params?: any): ApiResponse<WrappedResult<cyrian.api.settings.SettingsParams>> {
    return request({
      method: 'get',
      url: '/settings',
      params,
    });
  },
  set(data: cyrian.api.settings.SetSettingsParams): ApiResponse<Result> {
    return request({
      method: 'post',
      url: '/settings/set',
      data,
    });
  },
};

export default settingsApi;
